/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { useEffect } from 'react';
import { useApolloClient } from '@apollo/client';
import { UserExchangeProviderDataQuery } from '../apollo';
import { useAlertModal } from './useAlertModal';
import { useIsDashboardPage } from './useIsDashboardPage';

export const useMinAum = (
  exchange: Nullish<Exchange>,
  exchangeWizardActive: boolean
) => {
  const client = useApolloClient();
  const { dispatch } = useAlertModal();
  const dashboardPage = useIsDashboardPage();

  useEffect(() => {
    if (!dashboardPage) return;
    if (exchangeWizardActive) return;
    if (!exchange?.aumBelowMinimum) return;

    dispatch(['setModalContent', 'aumBelowMinimum']);
  }, [dashboardPage, exchange, exchangeWizardActive, dispatch, client]);
};

type Exchange = UserExchangeProviderDataQuery['getUserExchanges'][number];
